import { render, staticRenderFns } from "./PassChangePopupComp.vue?vue&type=template&id=71eb8f4c&scoped=true&"
import script from "./PassChangePopupComp.vue?vue&type=script&lang=js&"
export * from "./PassChangePopupComp.vue?vue&type=script&lang=js&"
import style0 from "./PassChangePopupComp.vue?vue&type=style&index=0&id=71eb8f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb8f4c",
  null
  
)

export default component.exports